import OverviewRatings from "./ratings.component";

export default OverviewRatings;
